import { render, staticRenderFns } from "./knowledgeBase.vue?vue&type=template&id=992fb870"
import script from "./knowledgeBase.vue?vue&type=script&lang=js"
export * from "./knowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./knowledgeBase.vue?vue&type=style&index=0&id=992fb870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports